import { useEffect, useState } from 'react';
import useMenus from '../context/MenuContext';
import useParam from '../context/ParamContext';
import masterDataService from '../service/masterData.service';
import { generateAutocompleteItems } from '../utils/helper';

export const useBuilding = () => {
  const { menus, getMenus, getMenuSubMenuId, getCanEdit } = useMenus();
  const { getParam, params } = useParam();
  const [refetchTable, setRefetchTable] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [selectedValues, setSelectedValues] = useState({});
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  const [submenu, setSubmenu] = useState(null);
  const [canEdit, setCanEdit] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [dynProps, setDynProps] = useState([]);
  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    type: [],
    status: [],
    buildingGroup: [],
    classification: [],
    project: [],
  });
  const [autocompleteData, setAutocompleteData] = useState({});
  const [loading, setLoading] = useState(true);
  const [dynLoading, setDynLoading] = useState(true);
  const isLoading = loading || dynLoading;

  useEffect(() => {
    getMenus();
    getParam();
  }, []);

  useEffect(() => {
    if (submenu) {
      initDefaultValues();
    }
  }, [submenu]);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('building');
    setSubmenu(submenuId);
    setCanEdit(getCanEdit(submenuId));
  }, [menus]);

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .typeToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .groupToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .classificationToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          type: resp[0],
          status: resp[1],
          buildingGroup: resp[2],
          classification: resp[3],
          project: resp[4],
        };
        setAutocompleteData(aData);

        const filteredProject = aData.project.filter((p) => p.active);

        const acOptions = {
          type: generateAutocompleteItems(aData.type.typeItems, 'itemName', 'itemId'),
          status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
          buildingGroup: generateAutocompleteItems(aData.buildingGroup.projectGroupListitems, 'itemName', 'itemId'),
          classification: generateAutocompleteItems(aData.classification.classificationItem, 'name', 'id'),
          project: generateAutocompleteItems(filteredProject, 'projectName', 'projectId'),
        };
        setAutoCompleteOptions(acOptions);
        setLoading(false);
      })
      .finally(() => {
        //hideLoader();
      });
  };

  return {
    refetchTable: refetchTable || false,
    setRefetchTable: setRefetchTable || (() => {}),
    viewField,
    setViewField,
    selectedValues,
    setSelectedValues,
    operatorsDisabled,
    setOperatorsDisabled,
    submenu,
    params,
    canEdit,
    rowSelectionModel,
    setRowSelectionModel,
    autocompleteOptions,
    setAutoCompleteOptions,
    dynProps,
    setDynProps,
    loading,
    setLoading,
    dynLoading,
    setDynLoading,
    isLoading,
    autocompleteData,
  };
};
